import Splide from '@splidejs/splide';

const gk_articleBlock = {
  load() {
    const blocks = document.querySelectorAll('.ArticleBlock');
    blocks.forEach((block) => {
      if (block.dataset.gkInit) return;
      block.dataset.gkInit = '1';

      const mode = block.dataset.mode;

      if (mode === 'slider') {
        this.initSplide(block);
      }

      if (block.dataset.loadMore === '1') {
        this.initLoadMore(block);
      }
    });
  },

  /**
   * Mode "afficher tous les articles" : tous les articles sont rendus côté serveur,
   * ceux au-delà du premier lot portent .is-hidden et sont révélés par lots.
   */
  initLoadMore(block) {
    const button = block.querySelector('.ArticleBlock-loadmoreButton');
    const container = block.querySelector('.ArticleBlock-grid, .ArticleBlock-mosaic');
    if (!button || !container) return;

    const items = Array.from(container.querySelectorAll(':scope > .ArticleBlock-item'));
    const step = parseInt(block.dataset.loadMoreStep, 10) || 6;
    let visible = items.filter((item) => !item.classList.contains('is-hidden')).length || step;

    button.addEventListener('click', () => {
      const revealed = items.slice(visible, visible + step);
      revealed.forEach((item) => item.classList.remove('is-hidden'));
      visible += revealed.length;

      button.dataset.loaded = String(visible);

      if (visible >= items.length) {
        button.parentElement.remove();
      }

      // Focus sur le 1er article révélé : navigation clavier / lecteurs d'écran
      const first = revealed[0];
      if (first) {
        const link = first.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      }
    });
  },

  initSplide(block) {
    const splideEl = block.querySelector('.ArticleBlock-splide');
    if (!splideEl) return;

    const slideCount = splideEl.querySelectorAll('.splide__slide').length;
    if (slideCount < 2) return;

    const speed         = parseInt(block.dataset.speed, 10) || 750;
    const autoplay      = block.dataset.autoplay === '1';
    const autoplaySpeed = parseInt(block.dataset.autoplaySpeed, 10) || 5000;
    const rewind        = block.dataset.rewind === '1';
    const showArrows    = block.dataset.showArrows === '1';
    const showDots      = block.dataset.showDots === '1';

    const perPageDesktopLarge = parseInt(block.dataset.perPageDesktopLarge, 10) || 4;
    const perPageDesktop      = parseInt(block.dataset.perPageDesktop, 10) || 3;
    const perPageTabletLarge  = parseInt(block.dataset.perPageTabletLarge, 10) || 3;
    const perPageTablet       = parseInt(block.dataset.perPageTablet, 10) || 2;
    const perPageMobileLarge  = parseInt(block.dataset.perPageMobileLarge, 10) || 1;
    const perPageMobile       = parseInt(block.dataset.perPageMobile, 10) || 1;

    const safeMax = (n) => Math.min(n, slideCount);

    const splide = new Splide(splideEl, {
      type:       rewind ? 'loop' : 'slide',
      perPage:    safeMax(perPageDesktopLarge),
      perMove:    1,
      speed,
      autoplay,
      interval:   autoplaySpeed,
      pauseOnHover: true,
      pauseOnFocus: true,
      arrows:     showArrows,
      pagination: showDots,
      gap:        'var(--ab-gap, 16px)',
      breakpoints: {
        1199: { perPage: safeMax(perPageDesktop) },
        1023: { perPage: safeMax(perPageTabletLarge) },
         990: { perPage: safeMax(perPageTablet) },
         767: { perPage: safeMax(perPageMobileLarge) },
         399: { perPage: safeMax(perPageMobile) },
      },
    });

    splide.mount();
    splideEl._splide = splide;
  },

};

export default gk_articleBlock;
